import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline"

const ViewSectionHeader = ({ title, children, expandable, expanded, onExpandClicked, isFinalSection }) => {
  return (
    <div className={`${(isFinalSection && !expanded) && 'rounded-b-md'} flex items-center justify-between bg-ase-blue text-white font-semibold py-3 px-4`}>
      <div className="flex items-center gap-2">
        <p>{title}</p>

        {children}
      </div>

      {expandable && (
        <button
          onClick={onExpandClicked}
          className={`bg-white text-ase-blue font-semibold text-xs py-1 px-2 rounded-md`}
        >
          {expandable && expanded ? <ChevronUpIcon className='h-4 w-4' /> : <ChevronDownIcon className='h-4 w-4' />}
        </button>
      )}
    </div>
  )
}

export default ViewSectionHeader;
